module.exports = __webpack_public_path__ + "img/37800.a859d2ee.jpg";